import React, { useState, useEffect, useCallback } from 'react';
import { Form, Button, FormGroup, Input, Label, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import authorizedFetch, { authorizedPost } from '../../api-authorization/AuthorizedFetch';
import { safeParseResponse } from '../../../utils';

const AddOrganizationModal = ({ 
  isOpen, 
  toggle, 
  parentOrganizationId,
  onAdded 
}) => {
  const [organizationName, setOrganizationName] = useState('');
  const [organizationType, setOrganizationType] = useState('');
  const [availableOrganizationTypes, setAvailableOrganizationTypes] = useState([]);

  const fetchData = useCallback(async () => {
    var response = await authorizedFetch(`api/organizations/${parentOrganizationId}/organization-types`);
    var content = await safeParseResponse(response) || {};
    
    setAvailableOrganizationTypes(content.organizationTypes || []);
    setOrganizationType(content.organizationTypes[0]);
  }, [parentOrganizationId, setAvailableOrganizationTypes, setOrganizationType]);

  const organizationTypeChanged = (e) => {
    var selectedOrganizationType = availableOrganizationTypes.find(x => x.organizationTypeId === e.target.value);
    setOrganizationType(selectedOrganizationType);
  }

  const createOrganization = async (e) => {
    const requestData = { parentOrganizationId, organizationName, organizationTypeId: organizationType.organizationTypeId };
    await authorizedPost('api/organizations', requestData);

    onAdded && onAdded();
  }

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>
        Add {organizationType.organizationTypeName}
      </ModalHeader>
      <ModalBody>
        <Form>
          <FormGroup>
            <Label>Type</Label>
            <Input id="organizationType" name="organizationType" type="select" onChange={organizationTypeChanged} value={organizationType.organizationTypeId}>
              {availableOrganizationTypes.map(x =>
                <option value={x.organizationTypeId}>{x.organizationTypeName}</option>
              )}
            </Input>
          </FormGroup>
          <FormGroup>
            <Label>{organizationType.organizationName} Name</Label>
            <Input value={organizationName} onChange={(e) => setOrganizationName(e.target.value)} placeholder={`Sample ${organizationType.organizationTypeName}`} />
          </FormGroup>
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button
          color="primary"
          onClick={createOrganization}
        >
          Create
        </Button>
        {' '}
        <Button onClick={toggle}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default AddOrganizationModal;
